import { default as isEmpty } from 'lodash/isEmpty'
import { camelToSnakeCase } from 'utils'

export const updateThemeOverride = ({ originalPage, layoutUpdates }) => {
  const themeOverride = camelToSnakeCase(originalPage?.product?.themeOverride)

  const updatedThemeOverride = {
    ...themeOverride,
    ...layoutUpdates,
  }

  if (isEmpty(updatedThemeOverride?.edited_background || {}))
    updatedThemeOverride.edited_background = {}

  return {
    ...originalPage,
    product: {
      ...originalPage?.product,
      themeOverride: updatedThemeOverride,
    },
  }
}

export default updateThemeOverride
